import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DxTabsComponent } from 'devextreme-angular';
import { Observable } from 'rxjs';
import { Breadcrumb } from '../../class/appinterface';
import { ComponentService } from '../../services/component.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})

export class BreadcrumbsComponent implements OnInit {

  @ViewChild('nicaNavTabs', { static: true }) nicaNavTabs: DxTabsComponent;
  @Input() currentUrl
  @HostListener('window:popstate', ['$event'])
  
  onPopState(event) {
    event.stopPropagation();
    event.preventDefault()
    console.log('Back button pressed', event);
    this.router.url;
    console.log(this.router.url)
    history.pushState(null, '', this.router.url);

    this.selectedIndex = this.selectedIndex - 1

  }
  breadcrumbs$: Observable<Breadcrumb[]>;
  breadcrumbs: any[];
  active: string;
  selectedIndex: number =-1
  customChange: number = 0
  previusUrl;
  
  currentTabId?:any;

  constructor(private menuService: NicaMenuService, private router: Router, private componentService: ComponentService,private activatedroute: ActivatedRoute,) {}



  ngOnInit() {


    this.menuService.previousUrl$.subscribe(prevUrl => {
      this.previusUrl = prevUrl
    })
    if(environment.SHOW_RENTRI==true){
      this.breadcrumbs = [
        
        {
          api: "",
          service: "",
          titolo: "Home",
          breadcrumb: "Home",
          currentTabId: "0",
          currentTabName: "Home",
          queryFilter: "",
          data: "",
          filter: "",
          helpDoc: "",
          componentName: "HomepagewwComponent",
          templateView: "",
          descEvent: "",
          path: "/main/home?currentTabId=0&currentTabName=Home"
        },
        {
          api: "",
          service: "",
          titolo: "Utenti",
          breadcrumb: "Utenti",
          currentTabId: "1",
          currentTabName: "Utenti",
          queryFilter: "",
          data: "",
          filter: "",
          helpDoc: "",
          componentName: "AnaUtentiComponent",
          templateView: "",
          descEvent: "",
          path: "/main/gestione-utenti?currentTabId=1&currentTabName=Utenti"
        },

      ]
      this.currentTabId = this.breadcrumbs[0].currentTabId;
    }
    else{
    let currentTabsItems = sessionStorage.getItem('currentTabsItems')
    if (currentTabsItems) {
      this.breadcrumbs = JSON.parse(currentTabsItems);

      this.activatedroute.queryParams.subscribe((params) => {
        console.log(params)
        this.selectedIndex = this.checkValueExist(this.breadcrumbs,params)

        this.currentTabId = params.currentTabId;

      })
    } else {
      this.breadcrumbs = [
        {
          api: "",
          service: "",
          titolo: "Home",
          breadcrumb: "Home",
          currentTabId: "0",
          currentTabName: "Home",
          queryFilter: "",
          data: "",
          filter: "",
          helpDoc: "",
          componentName: "HomepagewwComponent",
          templateView: "",
          descEvent: "",
          path: "/main/home?currentTabId=0&currentTabName=Home"
        },
        {
          api: "",
          service: "",
          titolo: "Dashboard",
          breadcrumb: "Dashboard",
          currentTabId: "1",
          currentTabName: "Dashboard",
          queryFilter: "",
          data: "",
          filter: "",
          helpDoc: "",
          componentName: "DashboardComponent",
          templateView: "",
          descEvent: "",
          path: "/main/dashboard?currentTabId=1&currentTabName=Dashboard"
        }
 
      ]
      this.currentTabId = this.breadcrumbs[0].currentTabId;
      //this.selectedIndex = 0
      //this.nicaNavTabs.selectedIndex = this.selectedIndex;
    }
  }

    /*this.breadcrumbs$ = this.menuService.breadcrumbs
    this.active = this.router.url


    this.router.events.subscribe((event) => {
      console.log(event);
      if (event instanceof NavigationEnd ) {
        this.active = event.url;
       }
      })   */

    this.menuService.cronNavData.subscribe(navData => {

      if (Object.keys(navData).length) {

        let checkValueIndex = this.checkValueExist(this.breadcrumbs, navData);

        if (checkValueIndex > -1) {
          if (navData['close']) {


            this.closeTab('', navData);
            return
          }
          this.breadcrumbs[checkValueIndex] = navData
        } else {

          this.breadcrumbs.push(navData);
        }
        //console.log(this.breadcrumbs)
        if (checkValueIndex == -1) {

          if (navData['close']) {
            this.closeTab('', navData);
            return
          }

          this.selectedIndex = this.checkValueExist(this.breadcrumbs, navData)
        } else {
          this.selectedIndex = checkValueIndex;
          //alert(this.selectedIndex)
        }

        this.customChange = this.selectedIndex
        //this.selectedIndex = -1;
      }

      this.menuService.setCronNavArray(this.breadcrumbs)


      let nTabs = this.breadcrumbs.length;
      this.componentService.setNumberOfNav(nTabs);

      this.componentService.numberOfNav.subscribe(reeee=>{

//        console.log('numberOfNav',reeee);

      })
    })
  }
  
  checkValueExist(arrayObjFind, navData) {
    let index = 0
    if (Array.isArray(arrayObjFind)) {
      index = arrayObjFind.findIndex(item => {
        if(item.componentName)return item.currentTabId === navData.currentTabId || item.componentName === navData.componentName
        else return item.currentTabId === navData.currentTabId

      })


    }

    return index
  }

  //***Eventi TABS***//
  tabClick(event) {
    this.router.navigateByUrl(event.itemData.path, {
      skipLocationChange: false,
      replaceUrl: true
    })
    this.nicaNavTabs.selectedIndex = this.selectedIndex;
    //console.log(event.itemData)
  }

  onOptionChanged(e) {
    //console.log(e)
    if (e.name == "selectedItemKeys" && (this.customChange > 0 )) {
      e.component.option('selectedIndex', this.selectedIndex)
      //this.selectedIndex = this.customChange;
      this.customChange = -1


    }
  }

  closeTab(event, item) {
    /* event.stopPropagation();
    event.preventDefault(); */
    this.componentService.removeOptionalParameter(item.currentTabId)
    let index = item.currentTabId;
    let theIndex;
    theIndex = this.breadcrumbs.findIndex(itm => {
      
      return itm.currentTabId === index

    })
    let filter=undefined
    if(item.filter)
      filter = JSON.parse(item.filter)
    // Per il momento la gestione è manuale, nel senso che io so che venngo dal movimento, troverò un modo per rendere il sistema più dinamico e leggero
    if(filter && typeof filter.movimento != 'undefined'){
      if(filter.serviceId != item.service){

        return
      }
      if(filter.movimento && filter.serviceId == item.service){
        let element=  this.breadcrumbs.find(itm => {
          if(itm.api)return itm.api ===  filter.provieniDa
          else return itm.currentTabId==filter.vengoDaId
        })

        let indexM = element!==undefined?this.breadcrumbs.indexOf(element):0
        
      const data = !item.data ? null : JSON.parse(item.data)
      const id =  item.id 
      const service  = this.breadcrumbs[theIndex]['service'];
      const api  = this.breadcrumbs[theIndex]['api'];
      const currentTabId = this.breadcrumbs[theIndex]['currentTabId']  


      let dataToSend = {

        id:id,
        service:service,
        api:api,
        dataField:filter.dataField,
        accessoringData:filter.accessoringData,
        name:'returnCreatedData',
        guid:currentTabId

      } 
      const urlm = this.breadcrumbs[indexM].path;
      this.router.navigateByUrl(urlm,
        {
       
          skipLocationChange: false,
          replaceUrl: true
        }).then(res => {
          this.componentService.setOutputComponent(dataToSend)
          this.breadcrumbs.splice(theIndex, 1);
          sessionStorage.setItem('currentTabsItems',JSON.stringify(this.breadcrumbs))
          this.componentService.destroyComponentNavigationTab(index)
          this.componentService.destroyComponentNavigation()
        })
      
      //this.componentService.setData(service,dataToSend)
         
        return
      }
    }

    this.breadcrumbs.splice(theIndex, 1);
    sessionStorage.removeItem(index)
    let newIndex = theIndex - 1
    const url = this.breadcrumbs[newIndex].path;
    //console.log(url)
    this.componentService.setComponentNavigation([])

    this.router.navigateByUrl(url,
      {
     
        skipLocationChange: false,
        replaceUrl: true
      }).then(res => {

        if (res) {
          this.componentService.destroyComponentNavigationTab(index)
        }
      })


  }

  showCloseButton(e: any) {


    
    return this.breadcrumbs.length > 1;



  }
}
